// @ts-check
import React from "react"
import Chip from "../../../../components/atoms/misc/Chip.atom"
import { clsx } from "../../../../utils/strings.utils"
import {
  TEAM_VACATION_REQUESTS_SORT_BUTTON_OPTIONS,
  TEAM_VACATION_REQUESTS_FILTER_TYPES,
} from "../../../../consts/modules/vacations.consts"
import TeamMemberMultiselect from "../../../../components/molecules/TeamMemberMultiselect.molecule"

/** @typedef {import("../../../../consts/modules/vacations.consts")["TEAM_VACATION_REQUESTS_FILTER_TYPES"]} vacationRequestsFilterTypes */
/** @typedef {vacationRequestsFilterTypes[keyof vacationRequestsFilterTypes]} SelectedVacationType */

/**
 * @typedef {Object} TeamVacationRequestsHeaderProps
 * @property {SelectedVacationType} selectedVacationType
 * @property {(value: SelectedVacationType) => void} setSelectedVacationType
 * @property {number[]} selectedTeamMembers
 * @property {(value: number[]) => void} setSelectedTeamMembers
 */

/** @type {React.FC<TeamVacationRequestsHeaderProps>} */
const TeamVacationRequestsHeader = ({
  selectedVacationType,
  setSelectedVacationType,
  selectedTeamMembers,
  setSelectedTeamMembers,
}) => {
  return (
    <div className="team-vacation-requests-header flex flex-column gap-3">
      <div className="flex justify-content-between align-items-center relative">
        <h3 className="text-xl m-0 font-cairo">Solicitudes del equipo</h3>
      </div>
      <TeamMemberMultiselect
        optionValue="id"
        selectedTeamMembers={selectedTeamMembers}
        setSelectedTeamMembers={(value) => {
          setSelectedTeamMembers(value)
        }}
        resetFilterOnHide
        initiallySelected={[]}
        scrollHeight="417px"
        showNotActive={false}
        placeholder={
          <div>
            <i className="pi pi-user mr-2" />
            Integrantes
          </div>
        }
      />
      <div className="flex flex-column gap-2">
        <span className="text-sm">Ver:</span>
        <div className="order-buttons-container">
          {TEAM_VACATION_REQUESTS_SORT_BUTTON_OPTIONS.map((option) => (
            <Chip
              key={option.value}
              className={clsx(
                "p-button p-component p-button-primary",
                selectedVacationType === option.value ?
                  "bg-primary-highlight"
                : "p-button-outlined"
              )}
              template={option.label}
              onClick={() => setSelectedVacationType(option.value)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TeamVacationRequestsHeader
